import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const PendingTuitions = () => {
    const [tuitions, setTuitions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchTuitions();
    }, []);

    const fetchTuitions = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/tuition/pending');
            const data = await response.json();
            setTuitions(data);
        } catch (error) {
            
            console.error('Error fetching tuitions:', error);
        }
    };

    const handleDelete = async (tuitionId) => { 
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this tuition?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/tuition/delete/${tuitionId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedTuitions = tuitions.filter(tuition => tuition.id !== tuitionId);
                        setTuitions(updatedTuitions);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The tuition has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete tuition');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the tuition.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting tuition:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the tuition.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (tuitionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this tuition?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/tuition/approve/${tuitionId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful approval
                        const updatedTuitions = tuitions.filter(tuition => tuition.id !== tuitionId);
                        setTuitions(updatedTuitions);
                        
                        // Show success message
                        Swal.fire({
                            title: "Approved!",
                            text: "The tuition has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve tuition');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the tuition.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving tuition:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the tuition.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter tuitions based on search term
    const filteredTuitions = tuitions.filter(tuition => 
        (tuition.className && tuition.className.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.subject && tuition.subject.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.teacherName && tuition.teacherName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.teacherEmail && tuition.teacherEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.contact && tuition.contact.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING TUITIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Class Name</th>
                                    <th>Subject</th>
                                    <th>Teacher Name</th>
                                    <th>Start Date</th>
                                    <th>Time</th>
                                    <th>Contact</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTuitions.map((tuition) => (
                                    <tr key={tuition.id}>
                                        <td>{tuition.className}</td>
                                        <td>{tuition.subject}</td>
                                        <td>{tuition.teacherName}</td>
                                        <td>{new Date(tuition.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{new Date(`1970-01-01T${tuition.time}Z`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
                                        <td>{tuition.contact}</td>
                                        <td>{tuition.teacherEmail}</td>
                                        <td><a href="#!" id='view-website'>WEBSITE</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='app-details' onClick={() => handleApprove(tuition.id)}>APPROVE</a>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(tuition.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingTuitions;
